export enum SendingSessionStatusEnum {
  Created = 'created',
  Sent = 'sent',
}

export const getSendingSessionStatusText = (type: SendingSessionStatusEnum, t: (n: string) => string): string => {
  return t(`invoice:sendingSessionStatusText.${type}`) || t('invoice:invoiceSendingTypeText.okänt');
};
